<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 511.672 511.672"
>
  <path
    d="M469.039 255.836c0-112.209-32.604-206.711-32.604-206.711H75.221s-32.588 94.502-32.588 206.711c0 102.528 27.623 191.439 32.37 205.993 6.074 27.826 84.696 49.843 180.837 49.843 96.118 0 174.756-22.017 180.814-49.843 4.778-14.569 32.385-103.465 32.385-205.993z"
    fill="#8c4c4c"
  />
  <path
    d="M245.175 511.578a606.246 606.246 0 0 0 21.314 0V100.654h-21.314v410.924zM138.868 80.355c-.89 3.966-21.611 97.906-21.611 175.481 0 65.864 15.021 200.59 19.925 242.813 6.917 1.765 14.272 3.372 22.033 4.81-3.529-30.122-20.644-179.354-20.644-247.623 0-75.187 20.893-169.892 21.111-170.844l-20.814-4.637zM352.021 84.992c.219.952 21.111 95.595 21.111 170.844 0 68.269-17.114 217.485-20.643 247.623a349.826 349.826 0 0 0 22.017-4.81c4.903-42.255 19.926-176.949 19.926-242.813 0-77.575-20.706-171.516-21.58-175.481l-20.831 4.637z"
    fill="#723f3f"
  />
  <path
    d="M45.943 117.737zM255.84 154.557c-83.743 0-169.844-20.611-200.09-28.606a736.326 736.326 0 0 0-8.167 51.498c24.516 6.809 116.27 30.402 208.257 30.402 91.996 0 183.719-23.594 208.266-30.402a735.269 735.269 0 0 0-8.183-51.498c-30.231 8.01-116.207 28.606-200.083 28.606zM51.159 359.254a758.108 758.108 0 0 0 11.352 57.354c37.273 9.713 117.721 25.766 193.329 25.766 75.6 0 156.018-16.053 193.307-25.766 3.841-16.036 7.9-35.508 11.367-57.354-25.047 6.824-116.082 29.841-204.674 29.841-88.6 0-179.619-23.017-204.681-29.841z"
    fill="#e6e9ed"
  />
  <path
    d="M437.061 53.294c0 29.434-81.137 53.294-181.221 53.294-100.092 0-181.228-23.86-181.228-53.294C74.612 23.859 155.748 0 255.84 0c100.084 0 181.221 23.859 181.221 53.294z"
    fill="#a85d5d"
  />
  <path
    d="M181.216 53.294c0 5.887-4.778 10.665-10.665 10.665s-10.649-4.778-10.649-10.665 4.763-10.665 10.649-10.665 10.665 4.778 10.665 10.665z"
    fill="#434a54"
  />
</svg>
